export type GradeValue = 'scs2' | 'scs1' | 'grade6' | 'grade7' | 'seo' | 'heo' | 'eo' | 'ao' | 'aa';

export const gradeValueToLabel = (value: GradeValue) => {
  switch (value) {
    case 'scs2':
      return 'SCS2';
    case 'scs1':
      return 'SCS1';
    case 'grade6':
      return 'Grade 6';
    case 'grade7':
      return 'Grade 7';
    case 'seo':
      return 'SEO';
    case 'heo':
      return 'HEO';
    case 'eo':
      return 'EO';
    case 'ao':
      return 'AO';
    case 'aa':
      return 'AA';
    default:
      return value;
  }
};
